import { createPortal } from 'react-dom';
import { Toaster, ToastBar } from 'react-hot-toast';
import { useToastHost } from '@/lib/toastHost';

export function AppToaster() {
  const host = useToastHost();

  const toaster = (
    <Toaster
      toastOptions={{
        duration: 4000,
        style: {
          zIndex: 100000,
          margin: 18,
          padding: '12px 18px',
        },
        success: {
          iconTheme: {
            primary: 'var(--color-green-700)',
            secondary: 'var(--color-white)',
          },
        },
        error: {
          iconTheme: {
            primary: 'var(--color-red-700)',
            secondary: 'var(--color-white)',
          },
        },
      }}
      containerStyle={host ? { zIndex: 100000, position: 'absolute' } : { zIndex: 100000 }}
    >
      {(t) => (
        <ToastBar toast={t}>
          {({ icon, message }) => (
            <>
              {icon}
              {icon ? <span className='self-stretch w-px bg-slate-200 ml-2.5' /> : null}
              {message}
            </>
          )}
        </ToastBar>
      )}
    </Toaster>
  );

  return host ? createPortal(toaster, host) : toaster;
}
